/* Outlast — auto-rotating product card images.
   Each .auto-slide element cycles through its .slide images
   on a timer (default 2.5s, override with data-autoslide-interval). */
(function () {
  function startSlider(el) {
    var slides = el.querySelectorAll('.slide');
    if (slides.length < 2) {
      if (slides.length === 1) slides[0].classList.add('is-active');
      return;
    }
    var interval = parseInt(el.getAttribute('data-autoslide-interval'), 10) || 2500;
    var i = 0;
    slides[0].classList.add('is-active');

    setInterval(function () {
      slides[i].classList.remove('is-active');
      i = (i + 1) % slides.length;
      slides[i].classList.add('is-active');
    }, interval);
  }

  document.addEventListener('DOMContentLoaded', function () {
    document.querySelectorAll('.auto-slide').forEach(startSlider);
    document.querySelectorAll('[data-product-gallery]').forEach(startGallery);
    initMobileMenu();
    initHeaderSearch();
    initLangSwitcher();
  });

  function closeLangMenu() {
    var toggle = document.querySelector('[data-lang-toggle]');
    var menu = document.querySelector('[data-lang-menu]');
    if (!toggle || !menu) return;
    menu.hidden = true;
    toggle.setAttribute('aria-expanded', 'false');
  }

  function initMobileMenu() {
    var toggle = document.querySelector('[data-menu-toggle]');
    var header = document.querySelector('.site-header');
    var nav = document.querySelector('[data-utility-menu]');
    if (!toggle || !header || !nav) return;

    function closeMenu() {
      header.classList.remove('is-menu-open');
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      header.classList.remove('is-search-open');
      var searchToggle = document.querySelector('[data-search-toggle]');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
      closeLangMenu();
      var isOpen = header.classList.toggle('is-menu-open');
      toggle.setAttribute('aria-expanded', isOpen ? 'true' : 'false');
    });

    // Close the panel after tapping a link inside it.
    nav.addEventListener('click', function (e) {
      if (e.target.closest('a')) closeMenu();
    });

    // Close on outside click / Escape, since the panel is now reachable
    // at every screen width (not just mobile).
    document.addEventListener('click', function (e) {
      if (!header.classList.contains('is-menu-open')) return;
      if (header.contains(e.target)) return;
      closeMenu();
    });
    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeMenu();
    });
  }

  function initLangSwitcher() {
    var wrap = document.querySelector('[data-lang-switcher]');
    var toggle = document.querySelector('[data-lang-toggle]');
    var menu = document.querySelector('[data-lang-menu]');
    var header = document.querySelector('.site-header');
    if (!wrap || !toggle || !menu || !header) return;

    function openMenu() {
      header.classList.remove('is-search-open');
      header.classList.remove('is-menu-open');
      var searchToggle = document.querySelector('[data-search-toggle]');
      if (searchToggle) searchToggle.setAttribute('aria-expanded', 'false');
      var menuToggle = document.querySelector('[data-menu-toggle]');
      if (menuToggle) menuToggle.setAttribute('aria-expanded', 'false');
      menu.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
    }

    toggle.addEventListener('click', function () {
      if (menu.hidden) {
        openMenu();
      } else {
        closeLangMenu();
      }
    });

    document.addEventListener('click', function (e) {
      if (menu.hidden) return;
      if (wrap.contains(e.target)) return;
      closeLangMenu();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeLangMenu();
    });
  }

  function initHeaderSearch() {
    var toggle = document.querySelector('[data-search-toggle]');
    var closeBtn = document.querySelector('[data-search-close]');
    var panel = document.querySelector('[data-header-search]');
    var input = document.querySelector('[data-search-input]');
    var results = document.querySelector('[data-search-results]');
    var header = document.querySelector('.site-header');
    if (!toggle || !panel || !input || !results || !header) return;

    function openSearch() {
      header.classList.remove('is-menu-open');
      closeLangMenu();
      header.classList.add('is-search-open');
      panel.hidden = false;
      toggle.setAttribute('aria-expanded', 'true');
      window.setTimeout(function () { input.focus(); }, 50);
    }

    function closeSearch() {
      header.classList.remove('is-search-open');
      panel.hidden = true;
      toggle.setAttribute('aria-expanded', 'false');
    }

    toggle.addEventListener('click', function () {
      if (header.classList.contains('is-search-open')) {
        closeSearch();
      } else {
        openSearch();
      }
    });

    if (closeBtn) {
      closeBtn.addEventListener('click', function (e) {
        e.preventDefault();
        closeSearch();
      });
    }

    document.addEventListener('click', function (e) {
      if (!header.classList.contains('is-search-open')) return;
      if (panel.contains(e.target) || toggle.contains(e.target)) return;
      closeSearch();
    });

    document.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') closeSearch();
    });

    // Predictive results — fetch as the shopper types, no page navigation
    // required. Enter (or the search icon) still submits to the full
    // results page via the form's normal action.
    var debounceTimer = null;
    var currentController = null;

    function formatMoney(amount) {
      var n = parseFloat(amount);
      if (isNaN(n)) return '';
      return '₪' + n.toLocaleString('en-US', { minimumFractionDigits: 2, maximumFractionDigits: 2 });
    }

    var strings = window.themeStrings || {};

    function renderResults(query, products) {
      if (!products || products.length === 0) {
        var emptyText = (strings.searchNoResults || 'No products found for "__QUERY__".').replace('__QUERY__', query);
        results.innerHTML = '<p class="header-search__empty">' + emptyText + '</p>';
        return;
      }
      var html = products.map(function (p) {
        var img = p.image ? '<img class="header-search__item-img" src="' + p.image + '&width=80" alt="" loading="lazy">' : '<span class="header-search__item-img header-search__item-img--empty"></span>';
        return (
          '<a href="' + p.url + '" class="header-search__item">' +
            img +
            '<span class="header-search__item-info">' +
              '<span class="header-search__item-title">' + p.title + '</span>' +
              '<span class="header-search__item-price">' + formatMoney(p.price_min) + '</span>' +
            '</span>' +
          '</a>'
        );
      }).join('');
      var viewAllText = (strings.searchViewAll || 'View all results for "__QUERY__" →').replace('__QUERY__', query);
      html += '<a href="/search?q=' + encodeURIComponent(query) + '" class="header-search__view-all">' + viewAllText + '</a>';
      results.innerHTML = html;
    }

    input.addEventListener('input', function () {
      var query = input.value.trim();
      window.clearTimeout(debounceTimer);

      if (query.length < 2) {
        results.innerHTML = '';
        return;
      }

      debounceTimer = window.setTimeout(function () {
        if (currentController) currentController.abort();
        currentController = ('AbortController' in window) ? new AbortController() : null;

        fetch('/search/suggest.json?q=' + encodeURIComponent(query) + '&resources[type]=product&resources[limit]=6&resources[options][unavailable_products]=last', {
          signal: currentController ? currentController.signal : undefined
        })
          .then(function (res) { return res.json(); })
          .then(function (data) {
            var products = (data && data.resources && data.resources.results && data.resources.results.products) || [];
            renderResults(query, products);
          })
          .catch(function (err) {
            if (err && err.name === 'AbortError') return;
          });
      }, 250);
    });
  }

  function startGallery(el) {
    var track = el.querySelector('.product-gallery__track');
    var slides = el.querySelectorAll('.product-gallery__img');
    var prev = el.querySelector('.product-gallery__arrow--prev');
    var next = el.querySelector('.product-gallery__arrow--next');
    var counter = el.querySelector('.product-gallery__current');
    if (!track || slides.length < 2) return;

    var i = 0;
    function go(index) {
      i = (index + slides.length) % slides.length;
      track.style.transform = 'translateX(-' + (i * 100) + '%)';
      if (counter) counter.textContent = i + 1;
    }
    if (next) next.addEventListener('click', function () { go(i + 1); });
    if (prev) prev.addEventListener('click', function () { go(i - 1); });

    el.tabIndex = 0;
    el.addEventListener('keydown', function (e) {
      if (e.key === 'ArrowRight') go(i + 1);
      if (e.key === 'ArrowLeft') go(i - 1);
    });
  }
})();
